import Link from 'next/link';
import { cn } from 'common/utils';
import ArrowIcon from 'components/v2/atoms/arrow-icon';
import { Button } from 'components/v2/atoms/button';

interface AboutLPCtaButtonProps {
  className?: string;
  text: string;
  href?: string;
  type: 'default' | 'green' | 'greenWithArrow';
  position: 'header' | 'footer' | 'body' | string;
}

const AboutLPCtaButton = ({
  className = '',
  text = '無料で始める',
  href = '/',
  type = 'default',
  position,
}: AboutLPCtaButtonProps) => {
  let button = <></>;
  const onClick = () => {
    let currentPath = '';
    try {
      currentPath = window.location.pathname;
    } catch (error) {
      currentPath = '';
    }
  };
  switch (type) {
    case 'greenWithArrow':
      button = (
        <div className={cn('relative inline-block', className)}>
          <Button
            onClick={onClick}
            className="group relative overflow-hidden rounded-full bg-pp-green-primary px-4 py-2 text-base font-semibold text-white transition-all duration-200 hover:translate-y-[-2px] hover:shadow-lg md:px-8 md:py-4 md:text-lg"
          >
            {/* Animated background */}
            <div className="absolute -left-full top-0 z-0 size-full bg-pp-green-hover transition-all duration-1000 ease-out group-hover:left-[-20%]" />

            {/* Button content */}
            <span className="relative z-10 flex items-center gap-2">
              {text}
              <ArrowIcon size={20} />
            </span>
          </Button>
        </div>
      );
      break;
    case 'green':
      button = (
        <Button
          className={cn(
            'rounded-full px-4 py-2 text-base font-semibold md:px-6 md:py-[10px] md:text-lg',
            className,
          )}
          onClick={onClick}
          variant="defaultGreen"
        >
          {text}
        </Button>
      );
      break;
    default:
      button = (
        <Button
          onClick={onClick}
          className="border-1 rounded-full border-solid border-pp-border-primary bg-white px-4 py-2 text-base font-semibold hover:bg-gray-100 md:border-2 md:px-8 md:py-4 md:text-lg"
        >
          {text}
        </Button>
      );
      break;
  }

  return href ? (
    <Link href={href} target={href.startsWith('http') ? '_blank' : '_self'}>
      {button}
    </Link>
  ) : (
    button
  );
};

export default AboutLPCtaButton;
